import { Fragment } from "react";
import { useIsMobile } from "../hooks/use-media-query";

// Block within logo
const Block = ({ id, left, top, className }) => {
  const stylesObj = {
    left: `${left}px`,
    top: `${top}px`,
  };

  // Each block has an ID, className and styles to set position
  return (
    <>
      <div id={id} className={className} style={stylesObj}></div>
    </>
  );
};

// Logo component
const Logo = () => {
  // Use the same breakpoint as the rest of the project (640px)
  const isMobile = useIsMobile();

  // Get the appropriate logo based on screen size
  const getLogoASCII = () => {
    // Desktop - logo 38 x 7 (37 x 6)
    let logo = `
       ##   #   #        ##   ##   ## 
 # ##    # ### ### ###     # #    #   
# # # ####  #   #  #  # ####  ##   ## 
# # # #  #  #   #  #  # #  #    #    #
# # # ####  ##  ## ###  #### ###  ### 
                   #                  
                   #                  
`;
    if (isMobile) {
      // Mobile - logo 18 x 7 (17 x 6)
      logo = `
       ##   #   # 
 # ##    # ### ###
# # # ####  #   # 
# # # #  #  #   # 
# # # ####  ##  ##
                  
                  
`;
    }

    return logo.replaceAll(/^\n|\n$/g, "");
  };

  const logoData = getLogoASCII();

  // Build up an array of arrays, each containing the x, y position and if it's a block or blank
  const pos = [0, 0];
  const grid = [];
  for (const logoCharacter of logoData) {
    // Line break, set x to 0 and y to next line
    if ("\n" === logoCharacter) {
      pos[0] = 0;
      pos[1]++;
      // Push the block or blank into grid array, move onto next x position
    } else {
      grid.push([pos[0], pos[1], "#" === logoCharacter ? "block" : "blank"]);
      pos[0]++;
    }
  }

  // Return the grid, with each array item mapped to a Block function
  return grid.map(elem => {
    const id = `logoBlock:${elem[0]}.${elem[1]}`;
    const left = elem[0] * 16;
    const top = elem[1] * 16;
    const className = elem[2];

    // Return each child item as a fragment with unique key
    return (
      <Fragment key={id}>
        <Block id={id} left={left} top={top} className={className} />
      </Fragment>
    );
  });
};

export default Logo;
